import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  // -- Page container ----------------------------------------------------
  innerContainer: {
    height: "100%",
    overflowY: "auto",
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.06)",
      borderRadius: "10px",
    },
  },
  cardContent: {
    padding: 0,
    margin: 0,
    width: "100%",
  },

  // -- Top header row (title + video) ------------------------------------
  profileBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "28px",
  },
  headerTextSection: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "18px",
    color: "#1a1a1a",
    letterSpacing: "-0.2px",
  },

  // -- Skeleton loader ---------------------------------------------------
  skeletonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "300px",
    gap: "16px",
  },
  skeletonTextGroup: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
  },

  // -- Section cards -----------------------------------------------------
  box: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  sectionCard: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    border: "1px solid rgba(0,0,0,0.06)",
    boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
    padding: "28px 32px",
  },
  sectionTitle: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "14px",
    color: "#1a1a1a",
    letterSpacing: "0.2px",
    marginBottom: "20px",
    paddingBottom: "12px",
    borderBottom: "1px solid rgba(0,0,0,0.05)",
  },

  // -- Avatar area -------------------------------------------------------
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  avatarBox: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "16px 20px",
    backgroundColor: "rgba(77, 18, 119, 0.03)",
    borderRadius: "12px",
    border: "1px solid rgba(77, 18, 119, 0.07)",
  },
  avatarInfo: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "4px",
  },
  avatarHint: {
    fontFamily: "Poppins",
    fontSize: "12px",
    color: "#999",
    lineHeight: "1.4",
  },
  avatar: {
    height: "72px !important",
    width: "72px !important",
    cursor: "pointer",
    margin: 0,
  },
  changePhotoBtn: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: "600",
    color: "#4D1277",
    cursor: "pointer",
    textDecoration: "none",
    transition: "opacity 0.2s",
    "&:hover": { opacity: 0.7 },
  },
  imgErrorText: {
    fontFamily: "Poppins",
    fontSize: "12px",
    color: "#E34D59",
    marginTop: "4px",
  },

  // -- Fields grid -------------------------------------------------------
  fieldsContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexWrap: "wrap" as const,
    width: "100%",
    gap: "20px 24px",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      gap: "16px",
    },
  },
  fieldBox: {
    flex: "1 1 calc(33.33% - 24px)",
    minWidth: "220px",
    maxWidth: "100%",
  },
  fieldLabel: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "12.5px",
    color: "#777",
    marginBottom: "6px",
    textTransform: "uppercase" as const,
    letterSpacing: "0.5px",
  },

  // -- Buttons -----------------------------------------------------------
  button: {
    borderRadius: "10px",
    backgroundColor: "#4D1277",
    padding: "10px 28px",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13.5px",
    color: "#fff",
    textTransform: "none" as const,
    boxShadow: "none",
    transition: "background-color 0.2s, box-shadow 0.2s",
    "&:hover": {
      backgroundColor: "#3a0d5a",
      boxShadow: "0 4px 12px rgba(77, 18, 119, 0.2)",
    },
  },

  // -- Misc / legacy -----------------------------------------------------
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "30px",
    height: "calc(100vh - 220px)",
    overflowY: "scroll",
  },
  headerText: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "14px",
    color: "#1a1a1a",
  },
  marginTop: { marginTop: "1rem" },
  outlinedInput: { width: "100%" },
  circularProgressOverImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2,
  },
  circularProgressStyle: {
    height: "90%",
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;
